<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-lg-6 col-12">
        <div class="d-sm-flex justify-content-center">
          <div class="my-auto ms-auto">
            <soft-button class="mt-2" color="success" variant="gradient" size="sm" @click="save()">Aceptar
            </soft-button>
          </div>
        </div>
        <div class="card mt-4">
          <!-- <div class="p-3 pb-0 card-header">
            <div class="d-sm-flex justify-content-center">

              <div class="my-auto ms-auto">
                <soft-button class="mt-2" color="danger" variant="gradient" size="sm" @click="save()">Eliminar
                </soft-button>
              </div>
            </div>
          </div> -->
          <div class="card-body p-5">
            <div class="row">
              <form ref='cancelsForm' class="needs-validation" novalidate>
                <div class="">
                  <label>Cliente <span style="color:red">*</span> </label>
                  <select id="choices-customer" v-model="localValue.customer_id" class="form-control"
                    name="choices-customer" required>
                    <option v-for="item in clientOptions" :key="item.value" :value="item.value"> {{ item.label }}
                    </option>
                  </select>
                </div>
                <div class=" mt-3">
                  <label>Entidad <span style="color:red">*</span> </label>
                  <select id="choices-entity" v-model="localValue.entity" class="form-control" name="choices-entity"
                    required @change="onEntityChange">
                    <option v-for="item in entitiesOptions" :key="item.value" :value="item.value"> {{ item.label }}
                    </option>
                  </select>
                </div>
                <div class=" mt-3">
                  <div class="form-group">
                    <label for="numbers">Número <span style="color:red">*</span></label>
                    <input id="numbers" v-model="localValue.number" class="form-control"
                      placeholder="Indique el número de la entidad a reabrir" required />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification" />
    </div>
  </div>

</template>

<script>
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import SoftButton from "@/components/SoftButton.vue";

  export default {
    components: {
      SoftSnackbar,
      SoftButton
    },
    data() {
      return {
        localValue: {
          customer_id: '',
          entity: '',
          number: '',
          all: false
        },
        entitiesOptions: [
          {
            value: 'orders',
            label: 'Pedidos',
          },
          {
            value: 'orders_back',
            label: 'Devoluciones',
          },
          {
            value: 'purchases',
            label: 'Entradas de Proveedor',
          },
        ],
        clientOptions: [],
        textareaRead: false,
        notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
      }
    },

    computed: {
      clients() {
        return this.$store.state.customer.list.data;
      },
      cancelStatus(){
        return this.$store.state.administration.cancel.status;
      }
    },
    watch: {
      clients(values) {
        if (values) {
          let elements = [];
          for (let cliente of values.items) {
            if (cliente.name == 'CENTRAL')
              continue;
            elements.push({
              label: cliente.customer_sga,
              value: cliente._id
            })
          }
          this.clientOptions = elements;
        }
      },
      cancelStatus(newValue){
        if (newValue.canceled) {
          this.notificationInfo = {
            title: 'Genial!',
            message: 'Su petición ha sido atendida' ,
            status: 'success'
          }
          this.showNotification = true;
          this.closeNotification();
          setTimeout(() => {
            this.cleanForm();
            }, 200);
      } else if (newValue.error) {
        let message="Ha ocurrido un error al eliminar";
        const error= newValue.error.error;
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Lo Sentimos',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
      }
    },
    mounted() {
      this.getCustomers();
    },
    methods: {
      getCustomers() {
        let filter = {
          sort: {
            sort: 'customer_sga',
            order: 'ascending'
          }
        }
        this.$store.commit("customer/load", {
          filters: filter
        });
      },
      save() {
        let form = this.$refs.cancelsForm;
        form.classList.add('was-validated');
        if (form.checkValidity()) {
          this.$store.commit("administration/cancelEntities", this.localValue)
          form.classList.remove('was-validated');
        }
      },
      closeNotification(){
      const self= this;
      setTimeout(function () {
          self.showNotification = false
        },2500);
      },
      loadStatusNotification(value){
        if (value.status == 'KO') {
          this.notificationInfo = {
            title: 'Ups! Lo Sentimos',
            message: value.error,
            status: 'error'
          }
          this.showNotification = true;
          this.closeNotification();
        } else {
          this.notificationInfo = {
            title: 'Genial!',
            message: 'Su petición ha sido atendida' ,
            status: 'success'
          }
          this.cleanForm();
          this.showNotification = true;
          this.closeNotification();
        }
      },
      cleanForm(){
        this.localValue= {
          customer_id: '',
          entity: '',
          number: '',
          all: false
        }
      },
      onEntityChange(){
        this.localValue.number=''
      }
    },
  }
</script>

<style>

</style>